"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILAssignmentViewer = void 0;
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var enums_1 = require("../../shared/enums");
var il_icon_1 = require("../il-icon/il-icon");
var regular_icon_definitions_1 = require("../il-icon/regular-icon-definitions");
var il_default_avatar_1 = require("../il-student-card/il-default-avatar");
var subject_icon_1 = require("../subject-icon/subject-icon");
var typeography_common_1 = require("../typeography/typeography.common");
var user_config_1 = require("../../configs/user.config");
function ILAssignmentViewer(_a) {
    var sx = _a.sx, className = _a.className, children = _a.children, courseSubject = _a.courseSubject, onQuestionClick = _a.onQuestionClick, onLessonContentClick = _a.onLessonContentClick, avatar = _a.avatar, studentName = _a.studentName, _b = _a.dueIcon, dueIcon = _b === void 0 ? (react_1.default.createElement(il_icon_1.ILIcon, { type: enums_1.IconTypeEnum.FONT_AWESOME, icon: regular_icon_definitions_1.RegularIconDefinitions.LOCK_KEYHOLE, size: enums_1.IconSizeEnum.XXSMALL, sx: { maxHeight: '0.9rem' } })) : _b, dueText = _a.dueText;
    return (react_1.default.createElement(material_1.Box, { className: 'il-assignment-viewer ' + className, sx: __assign({}, sx) },
        react_1.default.createElement(material_1.Box, { className: "header", sx: {
                p: '1.5rem',
                display: 'flex',
                position: 'relative',
            } },
            react_1.default.createElement(material_1.Box, { sx: {
                    display: 'flex',
                    position: 'absolute',
                    left: '1.5rem',
                    minHeight: '2rem',
                } },
                react_1.default.createElement(subject_icon_1.SubjectIcon, { subject: courseSubject, sx: { width: '1.5rem', height: '1.5rem' } }),
                !!onLessonContentClick && (react_1.default.createElement(material_1.Button, { sx: {
                        ml: { sx: '0.7rem', sm: '1.25rem' },
                        maxWidth: '2rem',
                        maxHeight: '2rem',
                        width: '2rem',
                        height: '2rem',
                        minWidth: '2rem',
                        minHeight: '2rem',
                        borderRadius: '0.25rem',
                        backgroundColor: '#eef8fa',
                    }, "aria-label": "Lesson content", onClick: onLessonContentClick },
                    react_1.default.createElement(il_icon_1.ILIcon, { type: enums_1.IconTypeEnum.FONT_AWESOME, icon: regular_icon_definitions_1.RegularIconDefinitions.OUTLINED_OPEN_BOOK_ICON, size: enums_1.IconSizeEnum.XLARGE }))),
                !!onQuestionClick && (react_1.default.createElement(material_1.Button, { sx: {
                        ml: { sx: '0.7rem', sm: '1.25rem' },
                        maxWidth: '2rem',
                        maxHeight: '2rem',
                        width: '2rem',
                        height: '2rem',
                        minWidth: '2rem',
                        minHeight: '2rem',
                        color: 'text.secondary',
                        fontSize: '1.5rem',
                    }, onClick: onQuestionClick, "aria-label": "Lesson Help" }, "?"))),
            react_1.default.createElement(material_1.Box, { sx: {
                    position: 'relative',
                    margin: '0 auto',
                } },
                react_1.default.createElement(material_1.Box, { sx: {
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '0.275rem',
                    } },
                    react_1.default.createElement(material_1.Box, { sx: { display: 'flex', flexDirection: 'row', gap: '0.5rem' } },
                        react_1.default.createElement(material_1.Avatar, { sx: { height: '1.375rem', width: '1.375rem' } },
                            react_1.default.createElement(il_default_avatar_1.ILDefaultAvatar, { color: (avatar && user_config_1.userConfig.color[avatar]) || avatar })),
                        react_1.default.createElement(typeography_common_1.ILBody2, { sx: { fontWeight: 600 } }, studentName)),
                    react_1.default.createElement(material_1.Box, { sx: { display: 'flex', flexDirection: 'row', gap: '0.5rem', alignItems: 'center' } },
                        dueIcon,
                        !!dueText && react_1.default.createElement(typeography_common_1.ILBody1, null, dueText))))),
        children));
}
exports.ILAssignmentViewer = ILAssignmentViewer;
